import { request } from "./http";

export function createOrder(payload) {
    return request("/api/orders", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });
}
